export enum StripeSubscriptionType {
	year = 12,
	month = 1
}
